import { Typography } from "antd";
const { Title } = Typography;

export const Loading = () => {
    return <Title level={3}>Authentication in progress...</Title>
}